module.exports = __webpack_public_path__ + "h5/img/dfh.f3ab297a.png";